import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { JobFieldOption } from 'signup-constants/signupData/JobFieldOption';
import { bulkSetSignupDataSkip } from '../../store/signup-data/action-creators';
import { Data } from '../../signup-data/DATA';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { FlowManager } from '../../flow-management/FlowManager';
import { getCurrentStep } from '../../store/flow/selectors';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { getIsNewPortalCreated } from '../../store/app/selectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { isSignupDataCompleted } from '../../store/signup-data/selectors';
import { Step } from '../../views/Step';
import { updateFlow } from '../../store/flow/action-creators';
export const BranchBIAB004 = {
  name: 'BranchBIAB004',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.BIAB004) && getIsNewPortalCreated(state);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const flowSteps = getFlowSteps();
    dispatch(updateFlow(flowSteps.preVerification, flowSteps.postVerification, [Step.BusinessBox, ...flowSteps.postAccountCreation], flowSteps.postExistingAccountSelection));
    return FlowManager.pushNextSteps(Step.BusinessBox)(flow);
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};
const SurveySteps = [Step.CrmExperienceLevel, Step.HubInterest, Step.UseCase];
export const BranchBusinessBox = {
  name: 'BranchBusinessBox',
  stateCheck: state => {
    return isSignupDataCompleted(state, Data.BusinessBox) && getCurrentStep(state) === Step.BusinessBox;
  },
  rebuildFlow: (flow, _state, dispatch) => {
    dispatch(bulkSetSignupDataSkip({
      [Data.CrmExperienceLevel]: CrmExperienceOption.None,
      [Data.HubInterest]: HubInterestOption.Marketing,
      [Data.JobField]: JobFieldOption.Marketing
    }));
    return FlowManager.removeSteps(...SurveySteps)(flow);
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};